
// FancyDressActivity
import React from 'react';
import FieldTrip72025 from 'views/FieldTrip72025';

const FancyDressActivityPage = () => {
  return <FieldTrip72025/>;
};

export default FancyDressActivityPage;